import { supabase } from '../lib/supabase/client';

interface EmailResponse {
  success: boolean;
  error?: string;
}

export const emailService = {
  async sendNewsletterConfirmation(email: string): Promise<void> {
    try {
      const { data, error } = await supabase.functions.invoke('send-email', {
        body: {
          type: 'newsletter_confirmation',
          email: email,
        },
      });

      if (error) throw error;
    } catch (error) {
      console.error('Failed to send newsletter confirmation email:', error);
      throw error;
    }
  },

  async sendNewsletterSubscriptionNotification(email: string): Promise<void> {
    try {
      const { data, error } = await supabase.functions.invoke('send-email', {
        body: {
          type: 'newsletter_subscription_notification',
          email: email,
        },
      });

      if (error) throw error;
    } catch (error) {
      console.error('Failed to send newsletter subscription notification:', error);
      throw error;
    }
  },

  async sendConsultationConfirmation(
    email: string,
    bookingDetails: {
      fullName: string;
      phone?: string;
      companyName?: string;
      message?: string;
      bookingType: string;
      bookingId?: string;
    }
  ): Promise<EmailResponse> {
    try {
      const { data, error } = await supabase.functions.invoke('send-email', {
        body: {
          type: 'consultation_confirmation',
          email: email,
          data: bookingDetails,
        },
      });

      if (error) throw error;

      return { success: true };
    } catch (err) {
      return {
        success: false,
        error: err instanceof Error ? err.message : 'Failed to send consultation confirmation email',
      };
    }
  },

  async sendConsultationFollowup(
    bookingDetails: {
      fullName: string;
      email: string;
      phone?: string;
      companyName?: string;
      message?: string;
      bookingType: string;
    }
  ): Promise<EmailResponse> {
    try {
      const { data, error } = await supabase.functions.invoke('send-email', {
        body: {
          type: 'consultation_followup',
          email: bookingDetails.email,
          data: bookingDetails,
        },
      });

      if (error) throw error;

      return { success: true };
    } catch (err) {
      return {
        success: false,
        error: err instanceof Error ? err.message : 'Failed to send consultation follow-up email',
      };
    }
  },

  async sendEmailInquiryConfirmation(
    email: string,
    inquiryDetails: {
      fullName: string;
      message?: string;
      inquiryId?: string;
    }
  ): Promise<EmailResponse> {
    try {
      const { data, error } = await supabase.functions.invoke('send-email', {
        body: {
          type: 'email_inquiry_confirmation',
          email: email,
          data: inquiryDetails,
        },
      });

      if (error) throw error;

      return { success: true };
    } catch (err) {
      return {
        success: false,
        error: err instanceof Error ? err.message : 'Failed to send email inquiry confirmation',
      };
    }
  },
};